import { configureStore } from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import authSlice from "./features/authSlice";
import parkingSlice from "./features/findParkingSlice/findParking";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import userProfileSlice from "./features/getProfileDataSlice";
import appealDetailsSlice from "./features/appealSlice";
import pcnSlice from "./features/pcnSlice";
import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import getCardsListSlice from "./features/userCardsList";
import paymentSlice from "./features/paymentSlice";
import enquiriesSlice from "./features/enquiriesSlice";
import userSignUpStatus from "./features/personaldesktopslice";
import getFeedBackSlice from "./features/feedbackSlice";
import getAuditsLogSlice from "./features/auditLogSlice";
import vehicleDetailsSlice from "./features/vehicleSlice";
import costCentersSlice from "./features/costCenterSlice";
import employeeSlice from "./features/employeeSlice";
import lawyersSlice from "./features/lawyersSlice";
import calanderSlice from "./features/calanderSlice/calander";
import requestsSlice from "./features/requestsSlice/requests";
import notificationDetailsSlice from "./features/notificationSlice";
import chatSlice from "./features/chatSlice";

const persistConfig = {
  key: "role",
  storage,
};

const reducer = combineReducers({
  auth: authSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store:any = configureStore({
  reducer: {
    auth: persistedReducer,
    feedback: getFeedBackSlice.reducer,
    parking: parkingSlice,
    profile: userProfileSlice.reducer,
    cardsList: getCardsListSlice.reducer,
    paymentdetails: paymentSlice.reducer,
    enquiries: enquiriesSlice.reducer,
    personalDesktop: userSignUpStatus.reducer,
    auditLog:getAuditsLogSlice.reducer,
    pcn: pcnSlice.reducer,
    appealData: appealDetailsSlice.reducer,
    notificationsData: notificationDetailsSlice.reducer,
    vehicleData: vehicleDetailsSlice.reducer,
    costCenter: costCentersSlice.reducer,
    employee:employeeSlice.reducer,
    lawyers:lawyersSlice.reducer,
    calendar:calanderSlice.reducer,
    requests : requestsSlice.reducer,
    chat:chatSlice.reducer
  },
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export const authActions = authSlice.actions;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
